import React from 'react';
import { Layout, CreateTeam as Team } from '@components/team';

const CreateTeam = () => {
    return <Team />;
};

CreateTeam.Layout = Layout;
export default CreateTeam;
